'use strict';

const Enum = require('./enum');

module.exports.Password = Object.create(Enum, {
  /**
   * Tests if a password is complex enough.
   *
   * At minimum a password must have
   * - a length of 8 characters or more
   * - contain an upper case letter
   * - contain a lower case letter
   * - contain a number
   * - contain a non-alphanumeric character
   */
  isUserPasswordComplexEnough: {
    value: password => {
      // no password? not complex enough
      if (!password) {
        return false;
      }

      // required attributes of a password
      const requiredComplexity = [
        // 8 character minimum
        /.{8,}/,

        // upper case letters
        /[A-Z]/,

        // lower case letters
        /[a-z]/,

        // numbers
        /[0-9]/,

        // non-alphanumeric
        /[^a-zA-Z0-9]/,
      ];

      // aggregate the number of complexity attributes that apply to the given password
      const countPassed = function(satisfied, requirement) {
        return requirement.test(password) ? satisfied + 1 : satisfied;
      };

      // all required must be met
      return requiredComplexity.reduce(countPassed, 0) === requiredComplexity.length;
    },
    enumerable: true,
  },
});
